import { useAutoneTranslation } from '@autone/translations';
import { Separator, ToggleGroup, ToggleGroupItem } from '@autone/ui';
import { useCallback } from 'react';

import { type APP_NAME } from '../../../consts';
import {
  type TableNamesWithMatchSystemRecommendationToggle,
  useAssortmentSessionStorageAtom,
} from '../../../storage/session-storage';

interface MatchSystemRecommendationToggleProps {
  tableName: TableNamesWithMatchSystemRecommendationToggle;
}

export const MatchSystemRecommendationToggle = ({
  tableName,
}: MatchSystemRecommendationToggleProps) => {
  const { t } = useAutoneTranslation<typeof APP_NAME>();
  const [matchSystemRecommendation, setMatchSystemRecommendation] =
    useAssortmentSessionStorageAtom(
      `${tableName}.extrasMenu.matchSystemRecommendationToggle`,
    );

  type ToggleValue = typeof matchSystemRecommendation;

  const handleToggleFilter = useCallback(
    (value: ToggleValue | '') => {
      setMatchSystemRecommendation(value === '' ? 'off' : value);
    },
    [setMatchSystemRecommendation],
  );

  return (
    <div className="flex flex-row gap-2 items-center px-2 py-1 self-stretch justify-between">
      <label>{t('quick-filters.matches-recommendation.label')}</label>
      <ToggleGroup
        variant={'primary'}
        type={'single'}
        value={matchSystemRecommendation}
        onValueChange={handleToggleFilter as (v: string) => void}
      >
        <ToggleGroupItem value={'yes' satisfies ToggleValue}>
          {t('quick-filters.matches-recommendation.yes')}
        </ToggleGroupItem>
        <Separator orientation="vertical" />
        <ToggleGroupItem value={'no' satisfies ToggleValue}>
          {t('quick-filters.matches-recommendation.no')}
        </ToggleGroupItem>
      </ToggleGroup>
    </div>
  );
};
